import { useQuery } from '@tanstack/react-query';

import { clientsService } from '../services';

import { clientsKeys } from './useClients';

export function useClient(id: string | undefined) {
  return useQuery({
    queryKey: clientsKeys.detail(id ?? ''),
    queryFn: () => {
      if (!id) throw new Error('missing id');
      return clientsService.get(id);
    },
    enabled: Boolean(id),
  });
}
